"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = descToJSON;
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var arrayFormat = function arrayFormat(array, prefix) {
  return array.map(function (propType) {
    return propTypeFormat(propType, prefix);
  });
};
var shapeFormat = function shapeFormat(shape, prefix) {
  var props = Object.keys(shape).map(function (key) {
    var value = shape[key];
    var valueFormat;
    if (value.type && (value.type === 'arrayOf' || value.type === 'oneOfType' || value.type === 'oneOf') && Array.isArray(value.args)) {
      valueFormat = "\n".concat(propTypeFormat(value, "".concat(prefix, "    ")));
    } else if (value.type === 'shape') {
      valueFormat = "\n".concat(propTypeFormat(value, "".concat(prefix, "    ")));
    } else {
      valueFormat = propTypeFormat(value);
    }
    return "".concat(prefix, "  ").concat(key, ": ").concat(valueFormat);
  });
  return "".concat(prefix, "{\n").concat(props.join(',\n'), "\n").concat(prefix, "}");
};
var propTypeFormat = function propTypeFormat(propType) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var result;
  if (propType.type) {
    switch (propType.type) {
      case 'arrayOf':
        if (Array.isArray(propType.args)) {
          result = "".concat(prefix, "[\n").concat(arrayFormat(propType.args, "".concat(prefix, "  ")).join('\n'), "\n").concat(prefix, "]");
        } else if (propType.args.type === 'oneOfType') {
          result = "".concat(prefix, "[\n").concat(propTypeFormat(propType.args, "".concat(prefix, "  ")), "\n").concat(prefix, "]");
        } else {
          result = "".concat(prefix, "[").concat(propTypeFormat(propType.args), "]");
        }
        break;
      case 'bool':
        result = "".concat(prefix, "boolean");
        break;
      case 'func':
        result = "".concat(prefix, "function");
        break;
      case 'instanceOf':
        result = "".concat(prefix, "new ").concat(propType.args.name, "(...)");
        break;
      case 'objectOf':
        result = "".concat(prefix, "{ test: ").concat(propType.args.type, ", ... }");
        break;
      case 'oneOf':
        result = propType.args.map(function (a) {
          return "".concat(prefix).concat(a);
        }).join('\n');
        break;
      case 'oneOfType':
        if (Array.isArray(propType.args)) {
          result = arrayFormat(propType.args, prefix).join('\n');
        } else {
          result = "".concat(prefix).concat(propTypeFormat(propType.args));
        }
        break;
      case 'shape':
        result = "".concat(shapeFormat(propType.args, prefix));
        break;
      default:
        result = "".concat(prefix).concat(propType.type);
        break;
    }
  } else {
    result = "".concat(prefix, "custom");
  }
  return result;
};
var propTypeAsJson = function propTypeAsJson(propType, propName, defaultValue) {
  var documentation = _objectSpread(_objectSpread({}, propType.reactDesc), {}, {
    name: propName
  });
  if (defaultValue !== undefined) {
    documentation.defaultValue = defaultValue;
  }
  documentation.format = documentation.format || propTypeFormat(propType);
  return documentation;
};
function descToJSON(component) {
  var reactDesc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!component) {
    throw new Error('react-desc: component is required');
  }
  var documentation = _objectSpread({
    name: component.displayName || component.name
  }, reactDesc);
  if (reactDesc) {
    delete documentation.propTypes;
    if (reactDesc.propTypes) {
      var propTypes = [];
      Object.keys(reactDesc.propTypes).forEach(function (propName) {
        var propType = reactDesc.propTypes[propName];
        propTypes.push(propTypeAsJson(propType, propName, (component.defaultProps || {})[propName]));
      });
      if (propTypes.length > 0) {
        documentation.properties = propTypes;
      }
    }
  }
  return documentation;
}